module.exports = __webpack_public_path__ + "static/media/1011437.cb08cb14.png";